'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { SpecraCombobox } from '../lieutenants/combobox';
import { SpecraPersonOptionContent } from '../lieutenants/person-option';
function toComboboxOption(person, avatarSize) {
    return {
        content: /*#__PURE__*/ _jsx(SpecraPersonOptionContent, {
            avatarSize: avatarSize,
            avatarSrc: person.avatarSrc,
            description: person.description ?? [
                person.role,
                person.email
            ].filter((value)=>Boolean(value)).join(' · '),
            name: person.name
        }),
        disabled: person.disabled,
        keywords: [
            person.name,
            person.email,
            person.role,
            ...person.keywords ?? []
        ].filter((value)=>Boolean(value)),
        label: person.name,
        textValue: person.name,
        value: person.id
    };
}
/**
 * Searchable assignee/contact picker built from the generic combobox molecule.
 * Fetching, permissions, and creating a person remain owned by the host.
 */ function SpecraPersonPickerInner({ avatarSize = 24, onOptionChange, onPersonChange, people, searchPlaceholder = 'Search people…', selectedPerson, ...props }, ref) {
    const peopleById = React.useMemo(()=>new Map(people.map((person)=>[
                person.id,
                person
            ])), [
        people
    ]);
    const options = React.useMemo(()=>people.map((person)=>toComboboxOption(person, avatarSize)), [
        avatarSize,
        people
    ]);
    const selectedOption = React.useMemo(()=>selectedPerson ? toComboboxOption(selectedPerson, avatarSize) : undefined, [
        avatarSize,
        selectedPerson
    ]);
    return /*#__PURE__*/ _jsx(SpecraCombobox, {
        ...props,
        ref: ref,
        onOptionChange: (option)=>{
            onOptionChange?.(option);
            onPersonChange?.(option ? peopleById.get(option.value) ?? (selectedPerson?.id === option.value ? selectedPerson : undefined) : undefined);
        },
        options: options,
        searchPlaceholder: searchPlaceholder,
        selectedOption: selectedOption
    });
}
const SpecraPersonPickerRoot = /*#__PURE__*/ React.forwardRef(SpecraPersonPickerInner);
SpecraPersonPickerRoot.displayName = 'SpecraPersonPicker';
export const SpecraPersonPicker = SpecraPersonPickerRoot;
